import { defaultAppTheme } from "../../theme/defaultAppTheme";

function toCamelToken(group: string, shade: string): string {
  return `${group}${shade.charAt(0).toUpperCase()}${shade.slice(1)}`;
}

function flattenThemePalette(): Record<string, string> {
  const colors: Record<string, string> = {};
  Object.entries(defaultAppTheme.palette).forEach(([group, shades]) => {
    Object.entries(shades).forEach(([shade, value]) => {
      colors[toCamelToken(group, shade)] = value;
    });
  });
  return colors;
}

const GROUP_LABEL_PT: Record<string, string> = {
  primary: "Primário",
  secondary: "Secundário",
  greyscale: "Escala de cinza",
  black: "Preto",
  error: "Erro",
};

function buildColorSwatchLabels(): Record<string, string> {
  const labels: Record<string, string> = {};
  Object.entries(defaultAppTheme.palette).forEach(([group, shades]) => {
    const groupPt = GROUP_LABEL_PT[group] ?? group;
    Object.keys(shades).forEach((shade) => {
      labels[toCamelToken(group, shade)] = `${groupPt} · ${shade}`;
    });
  });
  return labels;
}

/**
 * Tokens shown in the style guide: full palette + breakpoints from `defaultAppTheme`
 * (same object as `ThemeProvider` in `src/index.tsx`).
 */
export const VISUAL_TOKENS = {
  colors: flattenThemePalette(),
  breakpoints: { ...defaultAppTheme.breakpoints },
  typography: defaultAppTheme.typography,
} as const;

export const COLOR_SWATCH_LABELS = buildColorSwatchLabels();
